module.exports = __webpack_public_path__ + "assets/img/crayon4.a4fb24bb.png";